import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;
const apikey = process.env.REACT_APP_API_KEY;

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("apiKey", apikey);
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (token) headers.set("Authorization", token);
      return headers;
    },
  }),
  tagTypes: ["users", "userDetails", "reportedUsers"], 
  endpoints: (builder) => ({

    getuserslist: builder.query({
      query: (body) => ({
        url: `/admin/getUsersList`,
        method: "POST",
        body,
      }),
      providesTags: ["users"],
    }),

    getreporteduserslist: builder.query({
      query: (body) => ({
        url: `/admin/getReportedUsers`,
        method: "POST",
        body,
      }),
       providesTags: ["reportedUsers"],
    }),

    getdashboarddata: builder.query({
      query: (body) => ({
        url: `/admin/getDashboardData`,
        method: "GET",
        body,
      }),
    }),

    
    getuserdetails: builder.query({
      query: (body) => ({
        url: `/admin/getUserDetails`,
        method: "POST",
        body,
      }),
        providesTags: ["userDetails"],
    }),

    changeuserstatus: builder.mutation({
      query: (body) => ({
        url: `/admin/changeUserStatus`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["users", "userDetails", "reportedUsers"],
    }),


  }),
});

// ✅ correct auto-generated hook
export const { useGetuserslistQuery, useGetreporteduserslistQuery, useGetdashboarddataQuery, useGetuserdetailsQuery,  useChangeuserstatusMutation } = usersApi;
